import styled from 'styled-components'
import { Color } from '@eduact/student-theme'
import { variant, space, SpaceProps, layout, LayoutProps } from 'styled-system'
import SingleLineCssTrim from '@Styles/SingleLineCssTrim'

export const StyledClassroomCard = styled.div.attrs(props => ({ dir: document.documentElement.dir }))<SpaceProps & LayoutProps>`
	${space};
	position: relative;
	width: 264px;
	/* height: 314px; */
	background-color: ${props => props.theme.colors.light};
	overflow: hidden; // to hide extending image sharp borders
	border-radius: 24px 24px 60px 60px;
	/* box-shadow: 6px 6px 12px 0 #dcdcdc, -5px -5px 12px 0 #dcdcdc, inset 0 0 3px 0 #dcdcdc; */
	cursor: pointer;

	/* Phones get a tighter card: the cover follows via its aspect ratio and
	   the image's 100% width, so nothing crops. */
	@media (max-width: 769px) {
		width: 224px;
		border-radius: 20px 20px 48px 48px;
	}
	${layout}
	img {
		width: ${props => (props.width ? '100%' : '')};
	}
	&[dir='rtl'] {
		svg {
			transform: scale(-1, 1);
		}
	}
`

/**
 * 22:13 is the ratio the admin cropper locks every classroom cover to, so the
 * box is that ratio too (264 x 156) and a correctly cropped upload lands with
 * nothing cropped and nothing squashed. The old 264x165 box was 1.6 against a
 * 1.692 source, and `object-fit: fill` squashed the difference. `cover` stays
 * as the fallback for legacy rows uploaded before the cropper enforced a ratio.
 */
export const StyledClassroomImage = styled.img`
	text-align: left;
	/* block: an inline img reserves descender space, drawing a ~2px white
	   seam between the cover and the card body. */
	display: block;
	/* Relative, not the card's 264px: the card narrows on phones and the
	   cover must track it — identical on desktop where the card is 264px. */
	width: 100%;
	aspect-ratio: 22 / 13;
	object-fit: cover;
`

export const Badge = styled.p`
	position: absolute;
	right: 0;
	top: 20px;
	padding: 4px 8px 4px 13px;
	background-color: black;
	color: white;
	border-radius: 10px 0 0 10px;
	font-size: 15px;
	font-weight: bold;
`

export const CardBody = styled.div`
	position: relative;
	width: 100%;
	height: 108px;
	padding: 10px 8px 14px 16px;
	box-shadow: inset 0px 0px 3px -2px #000;
	@media (max-width: 769px) {
		height: 96px;
		padding: 8px 8px 12px 12px;
	}
`

export const Title = styled.p`
	font-size: 14px;
	height: 28px;
	font-weight: bold;
	letter-spacing: 0.14px;
	word-break: break-word;
	line-height: 18px;
	max-height: 26px;
	${SingleLineCssTrim};
`

export const Instructor = styled.p`
	font-size: 12px;
	letter-spacing: 0.14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-height: 26px;
`

export const InfoWrapper = styled.div`
	position: absolute;
	bottom: 4px;
	display: flex;
	width: 90%;
	justify-content: space-between;
`

export const GradeWrapper = styled.div`
	display: flex;
`

export const Grade = styled.p`
	position: relative;
	font-size: 12px;
	font-weight: 600;
	color: #65617d;
	margin: 0 4px;
	overflow: hidden;
	text-overflow: ellipsis;

	&:hover {
		overflow: visible;
	}
`

export const SubjectWrapper = styled.div`
	position: relative;
	top: -8px;
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const Subject = styled.p`
	font-size: 8px;
	letter-spacing: 0.14px;
	color: #65617d;
`

export const SubjectImage = styled.img`
	width: 16px;
	height: 16px;
	color: #65617d;
`

export const CardButton = styled.button<{ variant: Color }>`
	${variant({ scale: 'buttonColors', prop: 'variant' })};
	border: none;
	width: 100%;
	height: 50px;
	color: white;
	font-size: 14px;
	font-weight: bold;
	padding-bottom: 10px;
	cursor: pointer;
	@media (max-width: 769px) {
		height: 42px;
		padding-bottom: 6px;
	}
`
